import createTokenUpdate from './Streams/createTokenUpdate';
import subscribeToTokenUpdate from './Subscribers/subscribeToTokenUpdate';
import subscribeToUserActionsResponse from './Subscribers/subscribeToUserActionsResponse';

const connectUserActionsApiSubscriptions = middleware => {
    const {
        config,
        userActions,
    } = middleware.state.stores;

    return [
        subscribeToTokenUpdate(
            createTokenUpdate(config.update$),
            middleware.apiServices.userActions.request$,
        ),
        subscribeToUserActionsResponse(
            middleware.apiServices.userActions.response$,
            userActions,
        ),
    ];
};

export default connectUserActionsApiSubscriptions;
